
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/site/tools/cost-calculator",
      function () {
        return require("private-next-pages/site/tools/cost-calculator.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/site/tools/cost-calculator"])
      });
    }
  